module.exports = __webpack_public_path__ + "img/product-2-tu.ce83634c.png";